import { useAuth0 } from '@auth0/auth0-react';
import React from 'react';
import { useSelector } from 'react-redux';
import clsx from 'clsx';
import { getSiteHeaderVariant, getTravelAgency } from '../../../store/slices/user';
import HeaderVariant from '../../../constants/HeaderVariant';
import { logoLayoutVariants, TwAttributionVariants } from '../../../constants';
import TravelwitsLogo from '../../../assets/svgs/travelwitsLogo.svg';

const Topbar = () => {
  const { isLoading } = useAuth0();
  const travelAgency = useSelector(getTravelAgency);
  const headerVariant = useSelector(getSiteHeaderVariant);
  const withBrandingTopBar = !isLoading && headerVariant === HeaderVariant.withBrandingTopBar;
  const doShowlogoLayoutVariant =
    travelAgency &&
    travelAgency.settings &&
    travelAgency.settings.logoLayoutVariant === logoLayoutVariants.LOGO_IMAGE_TEXT_VARIANT;
  const AdditionalAgencyTextLogo =
    travelAgency && travelAgency.settings && travelAgency.settings.AdditionalAgencyTextLogo;
  const doMakeTravelwitsLogoSmaller =
    travelAgency && travelAgency.siteTheme && travelAgency.siteTheme.doMakeTravelwitsLogoSmaller;
  let logoClass = 'w-24 h-6 lg:w-48 lg:h-8';
  if (doMakeTravelwitsLogoSmaller) {
    logoClass = 'w-24 h-6 lg:h-4';
  }

  const twAttributionVariant =
    travelAgency && travelAgency.siteTheme && travelAgency.siteTheme.TwAttributionVariant;
  const doShowAttributionUnderSearchBar =
    twAttributionVariant === TwAttributionVariants.UNDER_SEARCH_BAR;

  return withBrandingTopBar && !doShowAttributionUnderSearchBar ? (
    <div className="w-full bg-topbar">
      <div
        className={clsx(
          'container px-4 md:mx-auto h-16 flex items-center',
          doShowlogoLayoutVariant && AdditionalAgencyTextLogo ? 'justify-between' : 'justify-end',
        )}
      >
        {doShowlogoLayoutVariant && AdditionalAgencyTextLogo && (
          <img
            src={AdditionalAgencyTextLogo}
            alt="agency text logo"
            className="w-32 h-6 md:w-48 md:h-8"
          />
        )}
        <div className="flex flex-col lg:flex-row items-center gap-0 lg:gap-2">
          <div className="text-10 pr-12 lg:pr-0 lg:text-sm">Powered by</div>
          {/* oxlint-disable-next-line nextjs/no-html-link-for-pages */}
          <a href="/">
            <TravelwitsLogo className={logoClass} fill="black" />
          </a>
        </div>
      </div>
    </div>
  ) : null;
};

export default Topbar;
